export const shadow_none = "none";
export const shadow_grey_border = "1px solid #F7F7F7";
export const shadow_dark_grey_border = "1px solid #848484";
export const shadow_basic = "0 0 6px 0 rgba(0, 0, 0, 0.08)";
// export const shadow_highlighted = "0 1px 32px 0 rgba(0, 0, 0, 0.08)";
export const shadow_highlighted = "0 1px 10px 0 rgba(0, 0, 0, 0.08)";
export const shadow_very_highlighted = "12px 16px 48px 0 rgba(0, 0, 0, 0.08)";
